export default __webpack_public_path__ + "static/media/20190907_143622.48d0a413.jpg";